/**
 * Client-side moderate content check (mirrors backend/content_moderation.py).
 * Server validation is authoritative; this gives instant feedback before submit.
 */

export const CONTENT_MODERATION_MESSAGE =
  "This text contains language that isn't allowed.";

const MODERATE_WORD_TERMS = [
  "asshole",
  "bastard",
  "bitch",
  "bollocks",
  "bullshit",
  "clit",
  "cock",
  "cocksucker",
  "cunt",
  "dildo",
  "faggot",
  "fag",
  "fuck",
  "fucker",
  "fucking",
  "jizz",
  "kike",
  "motherfucker",
  "nigger",
  "nigga",
  "penis",
  "pussy",
  "rape",
  "rapist",
  "retard",
  "retarded",
  "shit",
  "shitty",
  "slut",
  "spic",
  "twat",
  "vagina",
  "wanker",
  "whore",
  "wtf",
];

const MODERATE_PHRASE_TERMS = [
  "kill yourself",
  "kys",
  "go die",
  "die bitch",
  "lynch",
];

const LEET_MAP = {
  "@": "a",
  4: "a",
  8: "b",
  3: "e",
  6: "g",
  1: "i",
  "!": "i",
  0: "o",
  5: "s",
  $: "s",
  7: "t",
  "+": "t",
};

function normalizeForModeration(text) {
  if (!text) return "";
  let folded = String(text).toLowerCase();
  for (const [from, to] of Object.entries(LEET_MAP)) {
    folded = folded.split(from).join(to);
  }
  folded = folded.replace(/[_\-.]+/g, " ");
  folded = folded.replace(/[^\w\s]/g, "");
  folded = folded.replace(/(.)\1{2,}/g, "$1$1");
  folded = folded.replace(/\s+/g, " ").trim();
  return folded;
}

export function textContainsBlockedLanguage(text) {
  if (!text || !String(text).trim()) return false;

  const normalized = normalizeForModeration(text);
  if (!normalized) return false;

  for (const phrase of MODERATE_PHRASE_TERMS) {
    if (normalized.includes(phrase)) return true;
  }

  const spaced = ` ${normalized} `;
  for (const term of MODERATE_WORD_TERMS) {
    const re = new RegExp(`\\b${term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`, "i");
    if (re.test(spaced)) return true;
  }

  const compact = normalized.replace(/\s/g, "");
  for (const phrase of MODERATE_PHRASE_TERMS) {
    if (compact.includes(phrase.replace(/\s/g, ""))) return true;
  }
  for (const term of MODERATE_WORD_TERMS) {
    if (term.length < 3) continue;
    const reCompact = new RegExp(
      `(?:^|[^a-z])${term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}(?:[^a-z]|$)`,
      "i"
    );
    if (reCompact.test(compact)) return true;
  }

  return false;
}

export function validateAllowedText(text, { fieldName = "Text", allowEmpty = false, maxLength } = {}) {
  const raw = (text || "").trim();
  if (!raw) {
    if (allowEmpty) return "";
    throw new Error(`${fieldName} cannot be empty`);
  }
  if (maxLength != null && raw.length > maxLength) {
    throw new Error(`${fieldName} must be at most ${maxLength} characters`);
  }
  if (textContainsBlockedLanguage(raw)) {
    throw new Error(CONTENT_MODERATION_MESSAGE);
  }
  return raw;
}
